import { css } from '@linaria/core';

const starRatingLabel = css``;

const starRatingIconContainer = css`
  gap: 2px;
  display: flex;
`;

const starRatingIcon = css`
  --color-rating-star-icon: #ffc33b;
  color: var(--color-rating-star-icon);
`;

const starRatingRoot = css`
  display: inline-flex;
  gap: 4px;
  align-items: center;
`;

export default {
  root: starRatingRoot,
  label: starRatingLabel,
  iconsContainer: starRatingIconContainer,
  icon: starRatingIcon,
};
